export class ColorPicker {
    private $input: JQuery;

    constructor($input?: JQuery) {
        this.$input = $input === undefined ? $('<input type="text" class="form-control" />') : $input;
        this.$input["minicolors"]({
            format: "hex",
            opacity: false,
            theme: "bootstrap",
        });
    }

    public getValue(): string {
        return this.$input["minicolors"]("value");
    }

    public setValue(value?: string): ColorPicker {
        return this.$input["minicolors"]("value", value);
    }

    public setError(hasError: boolean): ColorPicker {
        if (hasError) this.$input.addClass("is-invalid");
        else this.$input.removeClass("is-invalid");

        return this;
    }

    public renderTo($element: JQuery): ColorPicker {
        this.$input.appendTo($element);
        return this;
    }

    public static createFromFormCtrl($formControl: JQuery): ColorPicker {
        return new ColorPicker($formControl);
    }
}
